/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Badge } from 'react-bootstrap'; // eslint-disable-next-line
import avatar_img from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader'; // eslint-disable-next-line
import default_avatar from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
import LoginHistoryAccordian from './accordion/LoginHistoryAccordian';
import { copy } from './Common';
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
const UserActivity = props => {
	const { data, pageLanguageContent, profileId, loginHistoryData } = props;
	useEffect(() => {
		// eslint-disable-next-line
	}, [loginHistoryData]);

	/* function to copy content*/
	function copyContent(content) {
		copy(content);
	}

	return (
		<fieldset className='border p-2'>
			<legend className='w-auto'>{pageLanguageContent['PRL164'] ? pageLanguageContent['PRL164'] : ''}</legend>
			<Row>
				<Col sm='2'>
					<strong>{pageLanguageContent['PRL165'] ? pageLanguageContent['PRL165'] : ''}:</strong>
				</Col>
				<Col sm='8'>
					{!data?.emails && <> {pageLanguageContent['PRL166'] ? pageLanguageContent['PRL166'] : ''}</>}

					{data?.emails && data?.emails.length > 0 && (
						<>{data['emails']['0']['email'] ? data['emails']['0']['email'] : ''}</>
					)}
				</Col>
				<Col sm='2' className='text-right'>
					<Badge
						bg={''}
						className='copy_content ml-1 memBadges badge badge-warning'
						onClick={() => copyContent(data['emails']['0']['email'] ? data['emails']['0']['email'] : '')}
						data-toggle='tooltip'
						title={genPageData['GENCPY'] ? genPageData['GENCPY'] : ''}
						role='button'
					>
						<i className='fas fa-copy'></i>
					</Badge>
				</Col>
			</Row>
			<div className='legendAccordian'>
				<LoginHistoryAccordian
					data={data}
					pageLanguageContent={pageLanguageContent}
					profileId={profileId}
					loginHistoryData={loginHistoryData}
				/>
			</div>
		</fieldset>
	);
};
export default UserActivity;
